<div 
fxFlex 
fxLayout="column" 
[ngClass]="breakpointObserver.isMatched('(min-width: 1280px)') ? 'ft-parent-layout' : 'no-ft-parent-layout'"
>
  <router-outlet></router-outlet>
</div>

